module.exports = __webpack_public_path__ + "static/img/55817_0_dziecko ze smartfonem_tr.0f16e963.png";